import React from 'react';
import { Sellers } from './pages/sellersList';
import { SellersForm } from './pages/sellersForm';

export const SellersRoutes = [
  {
    path: '/corretores',
    exact: true,
    component: () => <Sellers />,
  },
  {
    path: '/corretores/novo',
    exact: true,
    component: () => <SellersForm />,
  },
  {
    path: '/corretores/edit/:id',
    exact: true,
    component: () => <SellersForm />,
  },
];
